import React from "react";

interface PageItemProps {
  readonly pageName: string;
  readonly isFirstItem?: boolean;
  readonly className?: string;
}

const truncatePageName = (pageName: string) =>
  pageName.length <= 24 ? pageName : `${pageName.substring(0, 24)}⋯`;

export const PageItem = ({ pageName, className, isFirstItem }: PageItemProps) => (
  <span className={`flex gap-2 text-sm ${className}`}>
    <span>{isFirstItem ? "" : "/"}</span>
    <span>{truncatePageName(pageName)}</span>
  </span>
);
